import { I18nextProvider } from "react-i18next";
import i18n from "../i18n/i18n";

// must match locales in embed.js
const availableLocales = ["fr", "en", "de", "es", "se", "en-GB", "en-gb"];

function getPreferedDayJsLocale() {
    if (!navigator || !navigator.languages) {
        return "en-gb";
    }
    for (idx in navigator.languages) {
        const lang = navigator.languages[idx];
        const prefix = lang.substring(0, 2);
        if (availableLocales.indexOf(prefix) >= 0) {
            return prefix;
        }
    }
    return "en-gb";
}

function isValid(locale) {
    return typeof (locale) === "string" && availableLocales.indexOf(locale) >= 0
}

function computeLocale(locale) {
    if (isValid(locale)) {
        return locale;
    }
    return getPreferedDayJsLocale();
}

export function withLocale(Component) {
    const I18NizedComponent = withI18n(Component);
    return ({ locale, ...props }) => <I18NizedComponent locale={computeLocale(locale).toLowerCase()} {...props} />
}

let localeInitialized = false;
function withI18n(Component) {
    return ({ locale, ...props }) => {
        if (!localeInitialized) {
            console.log(`withI18n render => initialize locale ${locale}`)
            i18n.changeLanguage(locale);
            localeInitialized = true;
        }
        return <I18nextProvider i18n={i18n}>
            <Component locale={locale} {...props} />
        </I18nextProvider>
    }
}
